export const ibuprofenOptions = [
  {
    label: "Ibum Forte Pure (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Ibunid dla dzieci Forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Ibutact (40mg/ml)",
    value: "0.025",
  },
  {
    label: "Axoprofen Forte (40mg/ml)",
    value: "0.025",
  },
  {
    label: "Babyfen (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Brufen (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Brufen Forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Bufenik (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Bufenik Forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Ibufen dla dzieci  (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Ibufen dla dzieci forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Ibum (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Ibum forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Ibuprom dla Dzieci (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Ibuprom dla Dzieci Forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Kidofen (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Kidofen max (250mg/5ml)",
    value: "0.02",
  },
  {
    label: "MIG dla dzieci (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "MIG dla dzieci Forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Milifen (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Nurofen dla dzieci (100mg/5ml)",
    value: "0.05",
  },
  {
    label: "Nurofen dla dzieci Forte (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Nurofen dla dzieci JUNIOR (200mg/5ml)",
    value: "0.025",
  },
];

export const paracetamolOptions = [
  {
    label: "Paracetamol Hasco Forte (240mg/5ml)",
    value: "0.02083",
  },
  {
    label: "APAP dla dzieci FORTE (200mg/5ml)",
    value: "0.025",
  },
  {
    label: "Calpol (120mg/5ml)",
    value: "0.041",
  },
  {
    label: "Calpol 6 Plus (250mg/5ml)",
    value: "0.02",
  },
  {
    label: "Panadol dla dzieci (120mg/5ml)",
    value: "0.041",
  },
  {
    label: "Paracetamol Aflofarm (120mg/5ml)",
    value: "0.041",
  },
  {
    label: "Paracetamol Galena (120mg/5ml)",
    value: "0.041",
  },
  {
    label: "Paracetamol Hasco (120mg/5ml)",
    value: "0.041",
  },
  {
    label: "Pedicetamol (100mg/1ml)",
    value: "0.01",
  },
];
